<template>
  <div class="d-flex justify-content-between px-lg-3 mb-3">
    <li v-if="list" class="dl-heading-list">{{ heading }}</li>
    <div v-else class="dl-heading pr-3">
      <h4>{{ heading }}</h4>
    </div>
    <div class="dl-img">
      <a :href="`${publicPath}${pdfPath}`" download>
        <img src="@/assets/01/icon_download.svg" />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "DivDownloadHeading",
  props: {
    heading: String,
    list: Boolean,
    pdfPath: String,
  },
  data() {
    return {
      publicPath: process.env.BASE_URL,
    };
  },
};
</script>

<style lang="scss" scoped>
.dl-heading {
  text-shadow: 1px 1px lightgrey;
}
.dl-img {
  img {
    width: 2rem;
  }
}
</style>
